import { httpClient } from "@/services";

export default {
	state: {
		settingsDocumentsTypes: [],
		documentsTypesDocumentsTypes: [],
		filtersDocumentsTypes: {},
		editDocumentsTypes: {},
	},
	mutations: {
		updateDocumentsTypes(state, { settings, items, filters }) {
			state.settingsDocumentsTypes = settings;
			state.documentsTypesDocumentsTypes = items;
			state.filtersDocumentsTypes = filters;
		},
		updateEditDocumentsTypes(state, { department }) {
			state.editDocumentsTypes = department;
		},
	},
	actions: {

		async deleteAccountDocumentsTypes({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/info/documents-types/${ id }`);
				if (data && data.status) {
					dispatch('getAccountDocumentsTypesList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountDocumentsTypesList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get("/info/documents-types");
				if (data) {
					commit('updateDocumentsTypes', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async onAccountDocumentsTypesEdit({ commit, dispatch }, args ) {
			try {
				const { id, sendInfo } = args;
				const { data } = await httpClient.put(`/info/documents-types/${ id }`, sendInfo);
				if ( data ) {
					commit('updateAccountSettings', data);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });
			} catch (e) {
				console.error(e);
			}
		},

		async onAccountDocumentsTypesSave({ commit, dispatch }, args) {
			// dispatch("actionPreloader", true);
			try {
				const { sendInfo } = args;
				const { data } = await httpClient.post("/info/documents-types", sendInfo);
				if ( data ) {
					commit('updateAccountSettings', data);
					// dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async getAccountDocumentsTypesEdit({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/info/documents-types/${ id }/edit`);

				if (data && data.status) {
					commit('updateEditDocumentsTypes', data);
					dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},
		// onDefaultList({ commit }) {
		// 	commit('updateDefaultList');
		// }
	},
	getters: {
		editDocumentsTypes: s => s.editDocumentsTypes,
		settingsDocumentsTypes: s => s.settingsDocumentsTypes,
		documentsTypesDocumentsTypes: s => s.documentsTypesDocumentsTypes,
		filtersDocumentsTypes: s => s.filtersDocumentsTypes,
	},
};
